import React from 'react';
import moment from 'moment';
import AvailableOn from '../../../Schedule/Component/AvailableOn';
import LocationOption from '../../../../../_components/Options/LocationOption';
import ReactDatePicker from '../../../../../_components/DatePicker/ReactDatePicker';
import ProfessionalOption from '../../../../../_components/Options/ProfessionalOption';
import RenderValidateMessage from '../../../../../stories/Validation/RenderValidateMessage';

import { useState } from 'react';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

function RescheduleAction({ type, eventItem, eventDate, eventDoctor, eventProvider, eventAvailableOn, rescheduleItem }) {
  const [show, setShow] = useState(false);
  const [date, setDate] = useState("");
  const [errors, setErrors] = useState({});
  const [doctor, setDoctor] = useState({});
  const [availableOn, setAvailableOn] = useState("");
  const [providerGroup, setProviderGroup] = useState({});

  const handleShow = (e) => {
    e.preventDefault();
    setErrors({});
    setDate(moment(eventDate).toDate());
    setDoctor(eventDoctor);
    setAvailableOn(eventAvailableOn);
    setProviderGroup(eventProvider);
    setShow(true);
  }

  const clearAndHideReschedule = () => {
    setDate("");
    setErrors({});
    setDoctor({});
    setAvailableOn("");
    setProviderGroup({});
    handleClose();
  }

  const handleClose = () => { setShow(false); }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!date) {
      errors.dateTime = 'Date is required.'
    } else if (moment(date).isBefore(new Date())) {
      errors.dateTime = 'Date must be upcoming.';
    }

    if (!providerGroup.value) {
      errors.providerGroup = 'Location is required.'
    }

    if (!doctor.value) {
      errors.doctor = 'Provider is required.'
    }

    if (availableOn && moment(availableOn).isSameOrBefore(moment())) {
      errors.availableOn = 'Available On must be an upcoming date.';
    }

    if (availableOn && date && moment(availableOn).isSameOrAfter(moment(date))) {
      errors.availableOn = 'Available On must be before appointment date.';
    }

    setErrors(errors);

    if (!errors.dateTime && !errors.doctor && !errors.providerGroup && !errors.questions && !errors.availableOn) {
      reschedule();
    }
  }

  const reschedule = () => {
    const data = {
      id: eventItem.id,
      type: eventItem.type,
      doctor: { id: doctor.value, name: doctor.label },
      eventDate: moment(date).format("LLL"),
      availableOn: availableOn && availableOn !== 'Immediately' ? moment(availableOn).format("LLL") : 'Immediately',
      providerGroup: { id: providerGroup.value, name: providerGroup.label },
    }
    if (data.type === 'Form') {
      data.form = { id: eventItem.form.id, name: eventItem.form.name };
    }
    else if (data.type === 'Telehealth') {
      data.preVisitQuestions = { id: eventItem.preVisitQuestions.id, name: eventItem.preVisitQuestions.name };
    }
    rescheduleItem(eventItem, data);
    clearAndHideReschedule();
  }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Reschedule</Tooltip>}
    >
      <button
        title="Reschedule"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-edit"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={clearAndHideReschedule}>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule {type}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="form-group mb-4">
            <div className="row">
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Provider</label>
                <ProfessionalOption defaultValue={doctor.value} handleSelected={(value, label) => setDoctor({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="doctor" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Location</label>
                <LocationOption defaultValue={providerGroup.value} handleSelected={(value, label) => setProviderGroup({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="providerGroup" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> {type === 'Form' ? "Complete By" : "Telehealth Appointment"} Date</label>
                <ReactDatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={5}
                  dateFormat="MMM d, yyyy h:mm aa"
                  className="form-control"
                  wrapperClassName="w-100"
                />
                <RenderValidateMessage errors={errors} field="dateTime" />
              </div>
              <div className="col-sm-12">
                <AvailableOn
                  sendOn={availableOn}
                  setAvailableOn={(date) => setAvailableOn(date)}
                  apptDate={date}
                  apptType={type === 'Form' ? 'axs-link' : 'telehealth'}
                />
                <RenderValidateMessage errors={errors} field="availableOn" />
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={validate}>Reschedule {type === 'Form' ? 'Form' : 'Telehealth Appointment'}</Button>
        <Button variant="secondary" onClick={clearAndHideReschedule}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default RescheduleAction;